<script>
import WhatsShare from "@/components/_Shared/WhatsShare/Index";

import { mapState } from "vuex";
import freshDesk from "@/utils/freshDesk";

export default {
  name: "App",
  components: {
    WhatsShare
  },
  computed: {
    ...mapState("preloader", ["active"])
  },
  created() {
    freshDesk.hideLauncher();
  }
};
</script>

<template>
  <div id="app">
    <whats-share />

    <transition name="down" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<style>
@import "assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue